export default __webpack_public_path__ + "static/media/sent.1f5d8aad.png";